export default {"src":"/_next/static/media/LogoBlack.7274f63b.svg","height":344,"width":1000,"blurWidth":0,"blurHeight":0};